import { gql } from '@apollo/client';

export const getInsuranceQuote = () => gql`
  query getInsuranceQuote($params: GetInsuranceQuote!) {
    getInsuranceQuote(params: $params) {
      claimId
      insuranceId
      totalDeductible
      totalReimbursement
      totalCopay
      metadata
      reimbursedProducts {
        sku
        observation
        unitReimbursement
        unitDeductible
        unitCopay
        coverage
        quantity
      }
    }
  }
`;

export type ReimbursedProduct = {
  sku: number;
  observation: string;
  unitReimbursement: number;
  unitDeductible: number;
  unitCopay: number;
  coverage: boolean;
  quantity: number;
};

enum TributaryDocument {
  BILL = 'BILL',
  DISPATCH_NOTE = 'DISPATCH_NOTE',
}

export enum QuoteStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  CANCELLED_FAILED = 'CANCELLED_FAILED',
  DISCARDED = 'DISCARDED',
}

export interface OrderInsurance {
  id: number;
  beneficiaryName: string;
  claimId: number;
  insuranceId: number;
  status: QuoteStatus;
  totalReimbursement: number;
  totalDeductible: number;
  totalCopay: number;
  reimbursedProducts: ReimbursedProduct[];
  tributaryDocument: TributaryDocument;
  metadata: Record<string, string>;
}

export type GetInsuranceQuoteParams = {
  params: {
    rut: string;
  };
};

export type GetInsuranceQuoteResponse = {
  getInsuranceQuote?: OrderInsurance;
};
